import React from 'react';
import classNames from 'classnames';
import { Listbox } from '@headlessui/react';

import Loading from '../../../shared/Loading';
import { ListBox } from '../../../shared/Dropdown';

export default function ApplicationDropdown({
  listOptions,
  contentItems,
  setContent,
}) {
  if (!listOptions) return <Loading className="w-7 h-7" />;

  const selected = listOptions.find((o) => o.id === contentItems);
  const mostRecent = selected === listOptions[0];

  return (
    <div>
      <div className="text-center">
        <ListBox
          initialValue={listOptions[0]?.id}
          buttonText={`${mostRecent ? 'Most Recent:' : ''} ${selected?.text}`}
          handleChange={(e) => setContent(e)}
          listBoxClass="my-3 relative"
          value={contentItems}
        >
          {listOptions.map((op) => (
            <Listbox.Option
              key={op.id}
              value={op.id}
              className={classNames(
                'cursor-pointer p-2 hover:bg-opaque-navy hover:text-white last:hover:rounded-b-md border-navy-blue border-opacity-30',
                { 'border-b': op !== listOptions[listOptions.length - 1] },
              )}
            >
              {op.text}
            </Listbox.Option>
          ))}
        </ListBox>
      </div>
      <div className="layer" />
    </div>
  );
}
